export enum AtlasGroup {
  THEMATIC_DATA = 'Catalogue',
  PREDEFINED_MAP = 'Observatoire',
}
